import axios from 'axios';

const resolveApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  try {
    const parsedUrl = new URL(configuredUrl);
    const isLocalHost = parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1';
    const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
    const runtimeIsRemote = runtimeHost && runtimeHost !== 'localhost' && runtimeHost !== '127.0.0.1';

    if (isLocalHost && runtimeIsRemote) {
      parsedUrl.hostname = runtimeHost;
      return parsedUrl.toString().replace(/\/$/, '');
    }

    return configuredUrl.replace(/\/$/, '');
  } catch (error) {
    return configuredUrl.replace(/\/$/, '');
  }
};

const API_BASE_URL = resolveApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const userAPI = {
  getAllUsers: () => api.get('/users'),
  getUserById: (id) => api.get(`/users/${id}`),
  getUserByBookingToken: (token) => api.get(`/users/public/${token}`),
  getServicesByUser: (userId) => api.get(`/appointments/services/${userId}`),
};

export const appointmentAPI = {
  bookAppointment: (data) => api.post('/appointments/book', data),
  getTrackingDetails: (token) => api.get(`/appointments/track/${token}`),
  getAvailableSlots: (userId, date, duration) => {
    const params = `userId=${userId}&date=${date}${duration ? `&duration=${duration}` : ''}`;
    return api.get(`/appointments/available-slots?${params}`);
  },
};

export const getTrackingStreamUrl = (token) => {
  const sanitizedBase = API_BASE_URL.replace(/\/$/, '');
  return `${sanitizedBase}/appointments/track/${encodeURIComponent(token)}/stream`;
};

export const workHoursAPI = {
  getWorkHours: (userId) => api.get(`/work-hours/${userId}`),
};

export default api;
